import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero, Reveal } from "@/components/ui-bits";
import api from "@/lib/api";

const Insights = () => {
  const [insights, setInsights] = useState([]);

  useEffect(() => {
    api.get("/insights").then((r) => setInsights(r.data)).catch(() => {});
  }, []);

  return (
    <>
      <PageHero
        eyebrow="Insights"
        lines={["Notes From the", "Engineering Floor."]}
        sub="Perspectives on cloud, DevOps, data & AI and software engineering from the teams building these systems every day."
      />
      <section className="mx-auto max-w-7xl px-6 pb-28 lg:px-10" data-testid="insights-grid">
        {insights.length === 0 ? (
          <p className="font-mono text-sm text-tark-dim">Articles are on the way.</p>
        ) : (
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {insights.map((post, i) => (
              <Reveal key={post.id} delay={(i % 3) * 0.07}>
                <Link
                  to={`/insights/${post.slug}`}
                  data-testid={`insight-card-${post.slug}`}
                  className="card-glow group flex h-full flex-col rounded-2xl border border-tark-line bg-tark-card p-8"
                >
                  <div className="flex items-center justify-between">
                    <span className="rounded border border-tark-blue/40 bg-tark-blue/10 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-tark-cyan">
                      {post.tag}
                    </span>
                    <ArrowUpRight className="h-4 w-4 text-tark-dim transition-all group-hover:text-tark-cyan" />
                  </div>
                  <h3 className="mt-6 font-display text-lg font-bold leading-snug tracking-tight group-hover:text-tark-cyan">
                    {post.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-tark-mut">{post.excerpt}</p>
                  <span className="mt-auto pt-6 font-display text-xs font-bold uppercase tracking-[0.2em] text-tark-blue group-hover:text-tark-cyan">
                    Read Article
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </>
  );
};

export default Insights;
